import Cookies from "js-cookie"
export class LocalStorageHelper {
    static async setItem(key: string, value: string) {
      return localStorage.setItem(key, value)
    }
  
    static async getItem(key: string) {
      const domain = process.env.REACT_APP_DOMAIN || ''
      return Cookies.get(key,{domain:domain})
    }
  
    static async removeItem(key: string) {
      return Cookies.remove(key)
    }
  
    static async clear() {
      return localStorage.clear()
    }
  }
  